// extracted by mini-css-extract-plugin
export default {"shortlistButton":"shortlist_buttons-module___shortlistButton___ade1d964","labelWrapper":"shortlist_buttons-module___labelWrapper___edcc8e1c"};